import React, { useState } from "react";
import { Box, FormControlLabel, Grid, Typography } from "@mui/material";
import Button from "../../../common/Button";
import Switch from "../../../common/Switch";
import { notifyError, notifySuccess } from "../../../../Utils/CustomNotifcations";
import { updateAccount } from "../../../../Actions/Accounts";
import { ServerInfo } from "../../../../Actions/serverSetting";
import { apiFetch } from "../../../../Utils/apiFetch";

const FleetPerformanceAnalytics = (props) => {
  const originalEnabled =
    props.selectedAccount?.attributes?.fleetPerformanceAnalytics || false;

  const [enabled, setEnabled] = useState(originalEnabled);

  const handleUpdateAccount = () => {
    const accountData = {
      ...props.selectedAccount,
      attributes: {
        ...props.selectedAccount.attributes,
        fleetPerformanceAnalytics: enabled,
      },
    };

    apiFetch(`/api/accounts/${props.selectedAccount.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(accountData),
    })
      .then((response) => {
        return response.json().then((res) => {
          if (!response.ok) {
            throw new Error(res?.message || "API request failed");
          }
          return res;
        });
      })
      .then((res) => {
        const account = res.data;

        if (res.status === "success") {
          props.dispatch(
            notifySuccess("Fleet Performance Analytics updated successfully")
          );

          props.updateSelectedAccount(account);
          props.dispatch(updateAccount(account));

          if (props.selectedAccount.id === 1) {
            props.dispatch(ServerInfo(account));
          }
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          let err = res?.message?.split(":");

          if (err?.length > 1) {
            err[1] = err[1].replace(")", "");
            props.dispatch(notifyError(props.translate(err[1])));
          } else {
            props.dispatch(notifyError(res.message));
          }
        }
      })
      .catch((error) => {
        props.dispatch(notifyError(error.message || error));
      });
  };

  const isUnchanged = enabled === originalEnabled;

  return (
  <div>
    <Box
      sx={{
        mb: 3,
        p: 2,
        borderRadius: 2,
        bgcolor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography variant="h6" fontWeight={600}>
        Fleet Performance Analytics
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mt: 0.5 }}
      >
        Enable this feature to allow Fleet Performance Analytics for this
        account. When enabled, users can access analytics insights,
        performance metrics, and related reporting features.
      </Typography>
    </Box>

    <Grid container spacing={2}>
      <Grid item md={6} sm={12} xs={12}>
        <FormControlLabel
          control={
            <Switch
              checked={enabled}
              onChange={(e) => setEnabled(e.target.checked)}
            />
          }
          label={
            <Typography fontWeight={500}>
              {enabled
                ? "Fleet Performance Analytics is Enabled"
                : "Fleet Performance Analytics is Disabled"}
            </Typography>
          }
        />
      </Grid>

      <Grid item xs={12}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpdateAccount}
          disabled={
            props.logInUser?.userType !== -1 || isUnchanged
          }
        >
          Update
        </Button>
      </Grid>
    </Grid>
  </div>
);
};

export default FleetPerformanceAnalytics;